import React from 'react'

// Components
import Blog from 'components/flex/Posts/Highlighted/HighlightedPosts'
import HighlightedPosts from 'components/flex/Posts/Highlighted/HighlightedProfessionals'
import HighlightedMembers from 'components/flex/Posts/Highlighted/HighlightedMembers'
import HighlightedStories from 'components/flex/Posts/Highlighted/HighlightedStories'

interface HighlightedShellProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_PostTypes
  location?: any
}

interface PostProps {
  [key: string]: any
}

const HighlightedShell: React.FC<HighlightedShellProps> = ({
  fields,
  location = {},
}) => {
  const types: PostProps = {
    blog: Blog,
    professionals: HighlightedPosts,
    members: HighlightedMembers,
    stories: HighlightedStories,
  }

  if (!fields.styletype || !types[fields.styletype]) {
    return null
  }

  const Component = types[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default HighlightedShell
